document.addEventListener('DOMContentLoaded', function() {
  const collectionItems = document.querySelectorAll('.collection-list--item');
  const collectionProducts = document.getElementById('collectionProducts');

  // Function to fetch collection products
  function fetchCollectionProducts(collectionHandle) {
    const url = `/collections/${collectionHandle}/products.json`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        renderProducts(data.products);
      })
      .catch(error => {
        console.error('Error fetching collection products:', error);
      });
  }

  // Function to render products
  function renderProducts(products) {
    collectionProducts.innerHTML = ''; // Clear previous products

    // Limit the number of products to 12
    const limitedProducts = products.slice(0, 12);

    limitedProducts.forEach(product => {
      const imageUrl = product.images.length > 0 ? product.images[0].src : 'path/to/default-image.jpg';
      const price = product.variants[0].price;
      const compareAtPrice = product.variants[0].compare_at_price ? product.variants[0].compare_at_price : null;

      let priceHTML = `$${price}`;
      if (compareAtPrice) {
        priceHTML = `<span style="text-decoration: line-through;">$${compareAtPrice}</span> $${price}`;
      }

      const productHTML = `
        <div class="product-card add-to-cart product-card-gift grid__item" data-variant-id="${product.variants[0].id}">
          <img src="${imageUrl}" alt="${product.title}">
          <div class="product-card-gift--content">
            <div class="prod-title">${product.title}</div>
            <div class="price"><b>${priceHTML}</b></div> 
          </div>
        </div>
      `;
      collectionProducts.innerHTML += productHTML;
    });

    document.querySelectorAll('.add-to-cart').forEach(button => {
      button.addEventListener('click', function() {
        const variantId = this.getAttribute('data-variant-id');
        addToCart(variantId);
      });
    });
  }

  // Function to display popup notice
  function showPopup(message, isSuccess = true) {
    const popup = document.createElement('div');
    popup.className = `popup-notice ${isSuccess ? 'success' : 'error'}`;
    popup.textContent = message;
    document.body.appendChild(popup);

    setTimeout(() => {
      popup.classList.add('show');
    }, 10);

    setTimeout(() => {
      popup.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(popup);
      }, 300);
    }, 3000);
  }

  // Function to add to cart
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      showPopup(`${data.title} successfully added to cart`, true);
      updateCart();
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      showPopup('Failed to add product to cart. Please try again.', false);
    });
  }

  // Function to update cart drawer and icon bubble without opening the drawer
  function updateCart() {
    fetch('/cart?view=drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update the cart drawer content
        const cartDrawer = document.querySelector('cart-drawer,#CartDrawer, [data-cart-drawer]');
        if (cartDrawer) {
          const newDrawerContent = doc.querySelector('cart-drawer,#CartDrawer, [data-cart-drawer]').innerHTML;
          cartDrawer.innerHTML = newDrawerContent;

          // Remove the .is-empty class if the cart has items
          const cartItems = cartDrawer.querySelectorAll('.cart-item');
          if (cartItems.length > 0) {
            cartDrawer.classList.remove('is-empty');
          }
        } else {
          console.error('Cart drawer element not found');
        }

        // Update the cart icon bubble
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        if (cartIconBubble) {
          const newBubbleContent = doc.querySelector('#cart-icon-bubble').innerHTML;
          cartIconBubble.innerHTML = newBubbleContent;
        } else {
          console.error('Cart icon bubble not found');
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
  }

  // Initialize collection handle and load initial products
  function initializeCollectionHandle() {
    const initialHandle = 'extra-wow';
    fetchCollectionProducts(initialHandle);
  }

  initializeCollectionHandle();

  // Add click event listeners to collection items
  collectionItems.forEach(function(item) {
    item.addEventListener('click', function() {
      collectionItems.forEach(function(el) {
        el.classList.remove('selected');
      });
      this.classList.add('selected');
      const collectionHandle = this.getAttribute('data-handle');
      if (collectionHandle) {
        fetchCollectionProducts(collectionHandle);
      }
    });
  });
});

// CSS for the popup notice
const style = document.createElement('style');
style.textContent = `
  .popup-notice {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #4caf50;
    color: white;
    padding: 15px;
    border-radius: 5px;
    font-size: 16px;
    opacity: 0;
    transition: opacity 0.3s, bottom 0.3s;
    z-index: 1000;
  }

  .popup-notice.error {
    background-color: #f44336;
  }

  .popup-notice.show {
    opacity: 1;
    bottom: 40px;
  }

  @media (max-width: 600px) {
    .popup-notice {
      width: 90%;
      font-size: 14px;
      padding: 10px;
      bottom: 10px;
    }

    .popup-notice.show {
      bottom: 20px;
    }
  }
`;
document.head.appendChild(style);
